// extracted by mini-css-extract-plugin
module.exports = {"main":"AllItems_main__3ciI1","allItems":"AllItems_allItems__2lXUZ"};